import configureStore from '../store';
import jwt_decode from "jwt-decode";

const TOKEN_KEY = 'oauth2authcodepkce-state';
const time = Math.floor(Date.now() / 1000);

const { persistor } = configureStore();



export const login = (accessToken) => {
    localStorage.setItem(TOKEN_KEY, `${accessToken}`);
}

export const logout = async () => {
    await persistor.purge();
    await persistor.flush();
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem('persist:root');
    sessionStorage.removeItem('persist:root');
}

export const isLogin = () => {
    let authToken = JSON.parse(localStorage.getItem(TOKEN_KEY,JSON.stringify(TOKEN_KEY)))
    if (authToken) {
        if(authToken.idToken) {
            let email = idToken()?.email;
            if(email && email.indexOf("@utah.gov") > 0) {
                let expiry = Math.floor(new Date(authToken.accessTokenExpiry) / 1000)
                if (expiry >= time) {
                    return true;
                }
                else if (expiry < time) {
                    logout()
                    return false;
                }
                else {return false}
            }
            return false;
        }
        else {
            return false;
        }
    }
    else if(!authToken || authToken === 'undefined'){
        return false
    }
}

export const authCode = () => {
    return localStorage.getItem(TOKEN_KEY);
}

export const idToken = () => {
    let tokenkey  = JSON.parse(localStorage.getItem(TOKEN_KEY,JSON.stringify(TOKEN_KEY)))
    let decoded = jwt_decode(tokenkey.idToken)
    return decoded
}